import {getUTCDateTimeForDisplay} from '../../../utils/utils';
import {Typography} from '@mui/material';
import {t} from 'i18next';
import {CustomGridColDef} from '../../common/aur-data-grid-pro/AurDataGridPro';
import {ONLY_DATE_SHOW_FORMAT} from '../../../constants/constants';

export interface IReportsRow {
  firstName: string;
  lastName: string;
  lastAccessOn: string;
}

type AurDataGridColDef = CustomGridColDef & {
  isSearchBoxRequired?: boolean;
  isBorderNotRequired?: boolean;
};

const getFullName = (row: IReportsRow | undefined) => {
  if (!row) return 'Unknown';
  const {firstName = '', lastName = ''} = row;

  if (firstName && lastName) {
    return `${lastName}, ${firstName}`.trim();
  }

  return firstName || lastName;
};

export const getColumns = (): AurDataGridColDef[] => [
  {
    field: 'userName',
    headerName: t('common.userName'),
    width: 310,
    sortable: false,
    renderCell: (params) => {
      const row: IReportsRow = params?.row as IReportsRow;
      return (
        <div className="cell-container" tabIndex={params.tabIndex}>
          <Typography className="typo-text body3_size list-text">
            {getFullName(row)}
          </Typography>
        </div>
      );
    },
  },
  {
    field: 'lastAccessOn',
    headerName: t('common.lastAccessed'),
    headerClassName: 'custom-header',
    width: 954,
    sortable: false,
    isBorderNotRequired: true,
    isDateColumn: true,
    renderCell: (params) => {
      const row: string = params?.row?.lastAccessOn as string;
      return (
        <div className="cell-container" tabIndex={params.tabIndex}>
          {row && (
            <Typography className="typo-text body3_size list-text">
              {getUTCDateTimeForDisplay(row, ONLY_DATE_SHOW_FORMAT)}
            </Typography>
          )}
        </div>
      );
    },
  },
];
export enum HostingUserSummaryData {
  none = 'None',
}
